/* Saiguen — video al hover en tarjetas de producto (solo desktop con puntero fino).
 * Horizon renderiza el slide de video de .card-gallery únicamente como su imagen de preview,
 * así que acá montamos un <video> propio, absoluto sobre la tarjeta, recién en el PRIMER hover.
 * preload="none" + src asignado en el hover => cero descargas al cargar la página y cero en mobile. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.card-gallery[data-saiguen-hover-video]';

  function setup(gallery) {
    if (gallery.__saiguenHoverVideo) return;
    gallery.__saiguenHoverVideo = true;

    var src = gallery.getAttribute('data-saiguen-hover-video');
    if (!src) return;
    var video = null;

    function mount() {
      video = document.createElement('video');
      video.className = 'saiguen-hover-video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'none');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      video.disablePictureInPicture = true;
      video.addEventListener('playing', function () {
        gallery.classList.add('saiguen-hover-video--playing');
      });
      video.src = src; // con preload="none" no se descarga hasta play()
      gallery.appendChild(video);
    }

    gallery.addEventListener('pointerenter', function () {
      if (!video) mount();
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    });

    gallery.addEventListener('pointerleave', function () {
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (e) { /* aún sin metadata */ }
      gallery.classList.remove('saiguen-hover-video--playing');
    });
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  scan(document);

  // Tarjetas que llegan después (filtros de colección, recomendaciones, editor de temas)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SELECTOR)) setup(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
